import AppContext from "@helpers/context";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import ChannelFormSupport from "../components/ChannelFormSupport";

const ChannelCreateSupport = () => {
  const { channelForm } = useContext(AppContext);
  const { t } = useTranslation();

  return (
    <div className="card-container p-4">
      <ChannelFormSupport form={channelForm} />
    </div>
  );
};

export default ChannelCreateSupport;
